/**
 * API severity vocabulary -> the four Carbon severity levels. The criticality
 * words follow the Help page's mapping (SHALL Critical, SHOULD High, MAY
 * Medium). Info and routine read as low. Case-insensitive; anything unknown is
 * low, so an unexpected value never renders as critical.
 */
import type { SeverityLevel } from './types'

const LEVELS: Record<string, SeverityLevel> = {
  critical: 'crit',
  crit: 'crit',
  shall: 'crit',
  high: 'high',
  should: 'high',
  medium: 'med',
  med: 'med',
  may: 'med',
  low: 'low',
  info: 'low',
  informational: 'low',
  routine: 'low',
}

export function severityFromApi(value: string | null | undefined): SeverityLevel {
  return (value && LEVELS[value.trim().toLowerCase()]) || 'low'
}

/** The word that follows each glyph (Shape-First Severity Rule). */
export const SEVERITY_WORD: Record<SeverityLevel, string> = {
  crit: 'Critical',
  high: 'High',
  med: 'Medium',
  low: 'Low',
}
